/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_SkippedInputs */

const en_status_skipped = /** @type {(inputs: Status_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skipped`)
};

const he_status_skipped = /** @type {(inputs: Status_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דולג`)
};

/**
* | output |
* | --- |
* | "skipped" |
*
* @param {Status_SkippedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_skipped = /** @type {((inputs?: Status_SkippedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_SkippedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_skipped(inputs)
	return he_status_skipped(inputs)
});